import { InternalLinkWrapper, InternalLinkStyle } from './styles';

const InternalLink = ({ isVisible, title, link }) => {
  return (
    <InternalLinkWrapper key={link} isVisible={isVisible}>
      <InternalLinkStyle href={`${process.env.CVNA_APP_SEO_BASE_URL}${link}`}>
        {title}
      </InternalLinkStyle>
    </InternalLinkWrapper>
  );
};

export default InternalLink;
